import "./CustomGenericModal.css";

import Modal from "@mui/material/Modal";
import CustomButton from "./CustomButton";
import InfoIconImgSrc from "../../assets/image/png/info.png";
import TickconImgSrc from "../../assets/image/png/tick.png";
import NegativeIconImgSrc from "../../assets/image/png/error.png";
import Fade from "@mui/material/Fade";
import { Warning, Info, Cancel } from '@mui/icons-material';

import { CircularProgress } from "@mui/material";


interface CustomPopupProps {
    type: "positive" | "success" | "negative" | "error";
    message: string | any[];
    leftButtonText?: string;
    rightButtonText?: string;
    onLeftButtonClick?: () => void;
    onRightButtonClick?: () => void;
    onClose?: () => void;
    modalOpen: boolean;
    loading?: boolean;
    showSummary?: boolean;
    leftButtonPadding?: string;
    confirmedOrders?: number;
    partiallyConfirmedOrders?: number;
    unavailableOrders?: number;
    filterConfirmedOrders?: () => void;
    filterPartiallyConfirmedOrders?: () => void;
    filterUnavailableOrders?: () => void;
    insideBulkInvoice?: boolean
    isBulkRejection?: boolean
    rejectionObj?:any
    showValidationError?: boolean
    filterValidationFailedOrders?: () => void;
  }

  const customStyle = {
    width: 22,
    height: 22,
    color: "#fff",
    marginTop: "5px",
  };

export const CustomBulkModal: React.FC<CustomPopupProps> = ({
    type,
    message,
    leftButtonText,
    rightButtonText,
    onLeftButtonClick,
    onRightButtonClick,
    onClose,
    modalOpen,
    loading,
    showSummary,
    confirmedOrders,
    partiallyConfirmedOrders,
    unavailableOrders,
    filterConfirmedOrders,
    filterPartiallyConfirmedOrders,
    filterUnavailableOrders,
    insideBulkInvoice = false,
    isBulkRejection,
    rejectionObj,
    showValidationError,
    filterValidationFailedOrders,
  }) => {
    const getTypeIcon = (type: string) => {
      switch (type) {
        case "positive":
          return InfoIconImgSrc;
        case "success":
          return TickconImgSrc;
        case "negative":
          return NegativeIconImgSrc;
        case "error":
          return NegativeIconImgSrc;
        default:
          return "";
      }
    };
  
    return (
      <Modal
        open={modalOpen}
        onClose={onClose}
        closeAfterTransition
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={modalOpen}>
          <div className={"CustomGenericModal_popup-container"} style={{width:"500px"}}>
            <div className="CustomGenericModal_popup-content">
              <div className="CustomGenericModal_popup-sign">
                {<img src={getTypeIcon(type)} />}
              </div>
              <div className="CustomGenericModal_popup-message" style={{marginBottom: "10px"}}>
                {Array.isArray(message)
                  ? message?.map((error: any) => {
                      const { ErrorCode, ErrorMessage } = error || {};
                      return (
                        <p style={{ fontWeight: 500, marginBottom: "10px" }}>
                          {`Error ${ErrorCode}`}:{" "}
                          <span style={{ fontWeight: 450, color: "#707070" }}>
                            {ErrorMessage}
                          </span>
                        </p>
                      );
                    })
                  : typeof message === "string"
                  ? message
                  : "Some error occurred"}
              </div>
              
              {showSummary && (
                !isBulkRejection ? (
                  <ul style={{ display: "flex", textAlign: "start", flexDirection: "column", color: "#707070", fontSize: "13px" }}>
                    {confirmedOrders !== undefined && confirmedOrders !== null && confirmedOrders !== 0 && (
                      <li>
                        <span style={{ textDecoration: 'underline', fontStyle: 'italic', cursor: 'pointer' }} onClick={() => filterConfirmedOrders?.()}>
                          {confirmedOrders}{`${insideBulkInvoice ? "" : " Pending"}`} {`${confirmedOrders > 1 ? "Orders" : "Order"}`}
                        </span>{' '}
                        <span>{`will be ${insideBulkInvoice ? "fully invoiced" : "fully confirmed"}`}</span>
                      </li>
                    )}
                    {partiallyConfirmedOrders !== undefined && partiallyConfirmedOrders !== null && partiallyConfirmedOrders !== 0 && (
                      <li>
                        <span style={{ textDecoration: 'underline', fontStyle: 'italic', cursor: 'pointer' }} onClick={() => filterPartiallyConfirmedOrders?.()}>
                          {partiallyConfirmedOrders}{`${insideBulkInvoice ? "" : " Pending"}`} {`${partiallyConfirmedOrders > 1 ? "Orders" : "Order"}`}
                        </span>{' '}
                        <span>{`will be partially ${insideBulkInvoice ? "invoiced" : "confirmed"} due to partial availability of stocks`}</span>
                      </li>
                    )}
                    {unavailableOrders !== undefined && unavailableOrders !== null && unavailableOrders !== 0 && (
                      <li>
                        <span style={{ textDecoration: 'underline', fontStyle: 'italic', cursor: 'pointer' }} onClick={() => filterUnavailableOrders?.()}>
                          {unavailableOrders}{`${insideBulkInvoice ? "" : " Pending"}`} {`${unavailableOrders > 1 ? "Orders" : "Order"}`}
                        </span>{' '}
                        <span>{`will be failed due to unavailability of stocks`}</span>
                      </li>
                    )}
                  </ul>
                ) : 
                <ul style={{ display: "flex", textAlign: "start", flexDirection: "column", color: "#707070", fontSize: "13px", marginBottom: "10px" }}>
                  {rejectionObj.invoiceNumbers !== undefined && rejectionObj.invoiceNumbers  !== null && rejectionObj.invoiceNumbers  !== 0 && (
                    <li>
                      <span style={{ fontStyle: 'italic',}} >
                        {rejectionObj.invoiceNumbers }{" Invoices"}
                      </span>{' '}
                      <span>{`will be rejected`}</span>
                    </li>
                  )}
                  {rejectionObj.orderNumbers !== undefined && rejectionObj.orderNumbers  !== null && rejectionObj.orderNumbers  !== 0 && (
                    <li>
                      <span style={{ fontStyle: 'italic', }}>
                        {rejectionObj.orderNumbers }{" Orders"}
                      </span>{' '}
                      <span>{`will be rejected`}</span>
                    </li>
                  )}
                </ul>
              )}
              { isBulkRejection &&
                <div style={{display: "flex", alignItems: "center", gap: "5px", justifyContent: "center", marginBottom: "10px"}}>
                  <div>
                    <p style={{color: "red", fontStyle: "italic", fontSize: "12px"}}>
                      Note: Rejection of invoices and orders cannot be reverted.
                    </p>
                  </div>
                </div>
              }
              {showValidationError &&
                <div style={{display: "flex", alignItems: "center", gap: "5px", justifyContent: "center", marginBottom: "10px"}}>
                  <div>
                      <div>
                        <span>Click{' '}</span>
                        <span style={{ textDecoration: 'underline', fontStyle: 'italic', cursor: 'pointer' }} onClick={() => filterValidationFailedOrders?.()}>
                        ‘Show Orders’
                        </span>
                        <span>{' '}to review.</span>
                      </div>
                  </div>
                </div>
              }
              <div className="CustomGenericModal_popup-buttons">
                {rightButtonText && onRightButtonClick && (
                  <CustomButton
                    onClick={onRightButtonClick}
                    flexGrow={0.4}
                    fontColor="#707070"
                    backgroundColor="#fff"
                    borderColor="#707070"
                  >
                    {rightButtonText}
                  </CustomButton>
                )}
                {leftButtonText && onLeftButtonClick && (
                  <CustomButton
                    onClick={onLeftButtonClick}
                    flexGrow={rightButtonText ? 0.4 : 1}
                  >
                    {loading ? (
                      <CircularProgress style={customStyle} />
                    ) : (
                      leftButtonText
                    )}
                  </CustomButton>
                )}
              </div>
            </div>
            <button className="CustomGenericModal_popup-close" onClick={onClose}>
              ×
            </button>
          </div>
        </Fade>
      </Modal>
    );
  };
  
